/* app/js/src/components/clipping-studio/panels/destination-tab/youtube-publish-settings/clipping-studio-youtube-publish-settings.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=clipping-studio-youtube-publish-settings.component.css.map */
